
          import "Button.styles_1hova67.linaria.css";
          import { styled } from "@linaria/react";
import { typeStyle, focusStyle } from "@carvana/showroom-css-theme";
export const DefaultButton = /*#__PURE__*/styled("button")({
  name: "DefaultButton",
  class: "d14aom7e"
});
          